/**
 * S-210 (B, 22.10.2026): skutek zmiany statusu w kanale dla raportu akcji masowej „Zmień status”.
 * Wydzielone z bulk-actions.ts, żeby dało się to sprawdzić testem bez całego paska akcji.
 */
var _NAZWY_KANALOW: Record<string, string> = {
  allegro: 'Allegro', woocommerce: 'WooCommerce', prestashop: 'PrestaShop', erli: 'Erli', ebay: 'eBay',
  tiktok: 'TikTok', vonhalsky: 'Von Halsky',
};
var _POWODY_POMINIECIA: Record<string, string> = {
  sync_disabled: 'wysyłanie statusu do kanału jest wyłączone w ustawieniach',
  no_marketplace_mapping: 'ten status nie ma odpowiednika w kanale',
  no_outbound_support: 'kanał nie przyjmuje statusu z SellBase',
  account_missing: 'brak konta sklepu w SellBase',
  not_woocommerce: 'zamówienie spoza sklepu WooCommerce',
  // 27.10.2026 (runda 2): powody ze wspólnej wysyłki na Allegro (core/services/allegro_wyslane)
  bezpiecznik: 'bezpiecznik środowiska zatrzymał zapis do Allegro (to nie jest produkcja)',
  no_account: 'brak konta Allegro zamówienia w SellBase',
};

/** S-210 (B, 22.10.2026): co zmiana statusu zrobiła w kanale. Raport akcji masowej pisał „zsynchronizowano do
 *  marketplace” przy każdym zamówieniu, także gdy Allegro odmówiło, wysyłka była wyłączona albo kanał (VH, TikTok)
 *  w ogóle nie przyjmuje statusu — 20 zamówień HurtowniaXXL/HOLDX zostało przez to na Allegro „Nowe”. */
export function skutekWKanale(res: any, zrodlo?: any): { info?: string; uwaga?: string; odmowa?: boolean } {
  var r = res || {};
  // Przegląd S-210: na liście `order.source` to obiekt {key, label, color} (sourceMetaFromRaw), nie tekst.
  var zr = zrodlo && typeof zrodlo === 'object' ? zrodlo.key : zrodlo;
  var src = String(r.source || zr || '').toLowerCase();
  var kanal = _NAZWY_KANALOW[src] || 'kanał';
  // Najpierw świadome pominięcie (żółte), potem odmowa kanału (czerwona) — Allegro przy wyłączniku daje oba pola.
  var pom = String(r.push_skipped || '').trim();
  if (pom) return { uwaga: 'Tylko w SellBase — ' + (_POWODY_POMINIECIA[pom] || pom) };
  var ostrz = String(r.allegro_sync_warning || r.warning || '').trim();
  if (ostrz) return { uwaga: ostrz.toLowerCase().indexOf(kanal.toLowerCase()) === 0 ? ostrz : kanal + ': ' + ostrz, odmowa: true };
  if (r.pushed || r.allegro_fulfillment_status) return { info: 'wysłane do: ' + kanal };
  return {};
}
